$(function() {
  if(!$('html.articles.new-from-rss').length) {
    return false;
  }

  var $rssImportModal = $('#rss-import-modal');

  $rssImportModal.on('show.bs.modal', function(e) {
    $rssImportModal.find('.title').text($(e.relatedTarget).data('title'));
    $rssImportModal.find('[name=url]').val($(e.relatedTarget).data('url'));
  });

  $('form.create-from-url').on('submit', function(e) {
    $rssImportModal
      .removeClass('fade')
      .on('hidden.bs.modal', function() {
        $('#loading-modal').modal('show');
      })
      .modal('hide');
  });
});

